import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class CommonSubscriptionGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isPaidUser = ((this.authService.user.isOwner || this.authService.user.isOutlet) && this.authService.user.isPaidUser) || this.authService.user.isAdmin;
    if (!isPaidUser) {
      this.router.navigate(['/dashboard']);
      return false;
    } else {
      return true;
    }
  }
}

